/**
 * Enforces "exactly one open at a time" for accordions marked with
 * `[data-single-open-accordion]`.
 *
 * Native `<details name="...">` grouping (used by blocks/_accordion-row.liquid)
 * already ensures opening one row closes any other open row in the same
 * group, so at most one can ever be open. The only remaining way to reach
 * zero open rows is clicking the currently-open row's own summary, which
 * natively toggles it closed — this listener blocks exactly that case, in
 * the capture phase, before the browser's native toggle happens.
 */
document.addEventListener(
  'click',
  (event) => {
    const target = /** @type {HTMLElement} */ (event.target);
    const summary = target.closest('[data-single-open-accordion] summary');
    if (!summary) return;

    const details = summary.closest('details');
    if (details?.open) {
      event.preventDefault();
    }
  },
  { capture: true }
);
